import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

const initialState = {
  ecard: null,
};

const lastEcardSlice = createSlice({
  name: "lastEcardSlice",
  initialState,
  reducers: {
    setEcard(state, { payload }) {
      const { ecard } = payload;
      state.ecard = ecard;
    },
  },
});

export const { actions } = lastEcardSlice;
export default lastEcardSlice.reducer;

export const useLastEcardActions = () => {
  const dispatch = useDispatch();

  const setLastEcard = (ecard) => {
    dispatch(lastEcardSlice.actions.setEcard({ ecard }));
  };

  return {
    setLastEcard,
  };
};
